import { z } from 'zod';
import { AdminRole } from '../shared.js';
// ── admin auth (FR-ADM-01, AC-ADM-01) ─────────────────────────────────────
export const AdminLoginInput = z.object({
    email: z.string().email().toLowerCase(),
    password: z.string().min(8),
});
export const AdminMfaInput = z.object({ code: z.string().regex(/^\d{6}$/) });
export const AdminTokens = z.object({
    accessToken: z.string(),
    mfaVerified: z.boolean(),
    role: z.union([AdminRole, z.literal('custom')]),
    /** Built-in key or the custom role's name — display only, never an authorization input. */
    roleName: z.string(),
    /** The principal's permission set; the console gates navigation and routes on this. */
    permissions: z.array(z.string()),
});
export const AdminMfaEnrol = z.object({ secret: z.string(), otpauthUrl: z.string() });
//# sourceMappingURL=schemas.js.map